import RadioCardListPage from "@components/RadioCardListPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

const OPTIONS = [
  { emoji: "📱", key: "socialMedia" },
  { emoji: "💼", key: "professional" },
  { emoji: "💙", key: "datingApps" },
  { emoji: "📸", key: "personalCollection" },
]

const HOME_OPTIONS = [
  { emoji: "🛠️", key: "redecorateMySelf" },
  { emoji: "👨‍👩‍👧", key: "shareWithFamily" },
  { emoji: "🎨", key: "workWithDesigner" },
  { emoji: "🔨", key: "planRenovation" },
]

export default function PhotoUsagePage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="photoUsageHomeDesign"
        options={HOME_OPTIONS}
      />
    )
  }
  return <RadioCardListPage translationKey="photoUsage" options={OPTIONS} />
}
